"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
exports.Features = {
    PAYMENTS: 'payments',
    INDIVIDUAL: 'individual',
    GROUPS: 'groups',
    COURSE: 'course',
    REMINDERS: 'reminders',
    SMS_REMINDERS: 'smsReminders',
    STAFF: 'staffMembers',
};
//# sourceMappingURL=active-features.const.js.map